import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const fetchusers = () => {
  return apiClient(ENDPOINTS.USERGETALL, { method: "GET" });
};

export const createusers = (userData) => {
  return apiClient(
    ENDPOINTS.USERPOST,
    { method: "POST", body: userData },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const deleteUser = async (userId) => {
  return await apiClient(`${ENDPOINTS.USERDELETE}/${userId}`, {
    method: "DELETE",
  });
};

export const updateUser = async (userData, userId) => {
  return await apiClient(`${ENDPOINTS.USERUPDATE}/${userId}`, {
    method: "PUT",
    body: userData,
  });
};
